module.exports = " <div class=\"list list-ios thin-border von-cascade\" _v-0c417cc8=\"\"> <label v-for=\"($index, f) in fields\" class=\"item item-ios item-icon-right\" @click=showCascadePanel($index) _v-0c417cc8=\"\"> {{ f }} <i class=\"icon ion-ios-arrow-right\" _v-0c417cc8=\"\"></i> <span class=item-note _v-0c417cc8=\"\">{{ value[$index] }}</span> </label> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-0c417cc8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cascade/index.vue
// module id = 252
// module chunks = 0